<template>
  <path
    d="M8.83 6.00024L5.13 2.30024C5.42 1.55024 6.15 1.00024 7 1.00024L17 1.01024C18.1 1.01024 19 1.90024 19 3.00024V16.1702L17 14.1702V6.00024H8.83ZM20.49 21.9002C20.1 22.2902 19.47 22.2902 19.08 21.9002L18.88 21.7002C18.58 22.4502 17.85 23.0002 17 23.0002H7C5.9 23.0002 5 22.1002 5 21.0002V7.83024L2.1 4.93024C1.71 4.54024 1.71 3.91024 2.1 3.52024C2.49 3.13024 3.12 3.13024 3.51 3.52024L20.48 20.4902C20.88 20.8802 20.88 21.5102 20.49 21.9002ZM15.17 18.0002L7 9.83024V18.0002H15.17Z"
  />
</template>
